import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mockClinicianName } from '@/data/mock';

const HOLD_MS = 2400;     // greeting + name fully visible
const EXIT_MS = 700;      // fade-out duration
const TOTAL_MS = HOLD_MS + EXIT_MS;

export function Welcome() {
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const t1 = window.setTimeout(() => setExiting(true), HOLD_MS);
    const t2 = window.setTimeout(
      () => navigate('/overview', { replace: true }),
      TOTAL_MS
    );
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, [navigate]);

  return (
    <main
      className={`min-h-screen grid place-items-center px-8 ${exiting ? 'welcome-exit' : ''}`}
    >
      <div className="text-center">
        <p className="welcome-rise text-[clamp(20px,2.4vw,28px)] font-light text-tertiary tracking-[-0.005em] m-0">
          Hola
        </p>
        <h1 className="welcome-rise-delayed text-[clamp(28px,3.6vw,44px)] font-medium tracking-[-0.018em] m-0 mt-2 leading-[1.15]">
          {mockClinicianName}
        </h1>
      </div>
    </main>
  );
}
